import React, { forwardRef, useImperativeHandle, useRef } from "react"

export type H5MediaInputRef = {
  openCamera: () => void
  openGallery: () => void
}

type Props = {
  onCameraCapture: (file: File) => void
  onGallerySelect: (files: FileList) => void
}

const hiddenStyle: React.CSSProperties = { display: "none" }

const H5MediaInput = forwardRef<H5MediaInputRef, Props>(function H5MediaInput(
  { onCameraCapture, onGallerySelect },
  ref,
) {
  const cameraRef = useRef<HTMLInputElement>(null)
  const galleryRef = useRef<HTMLInputElement>(null)

  useImperativeHandle(ref, () => ({
    openCamera: () => cameraRef.current?.click(),
    openGallery: () => galleryRef.current?.click(),
  }))

  return (
    <>
      <input
        ref={cameraRef}
        type="file"
        accept="image/*"
        capture="environment"
        style={hiddenStyle}
        onChange={(e) => {
          const file = e.target.files?.[0]
          if (file) onCameraCapture(file)
          e.target.value = ""
        }}
      />
      <input
        ref={galleryRef}
        type="file"
        accept="image/*,video/*"
        multiple
        style={hiddenStyle}
        onChange={(e) => {
          if (e.target.files?.length) onGallerySelect(e.target.files)
          e.target.value = ""
        }}
      />
    </>
  )
})

export default H5MediaInput
